import React from "react";
import WarehouseInventory from "./WarehouseInventory";
import { ALL_TABS } from "./utils/inventory.constants";

const STOCK_ONLY_TABS = ALL_TABS.filter((item) => item.key === "stock");

export default function WarehouseStockPage() {
  return (
    <WarehouseInventory
      initialTab="stock"
      allowedTabs={STOCK_ONLY_TABS}
      showTabs={false}
      pageTitle="Warehouse Stock"
      pageDescription="Manage active stock, review quantity availability, batch visibility, and low stock items for your warehouse."
    />
  );
}